import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Divider, Drawer, Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

// Constants & Helpers
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';

// UI Components
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Modal from '@Uilib/H3Modal';
import PRZText from '../../Common/UI/PRZText';

// Common Components
import HideValue from '../../Common/RestrictedAccess/HideValue';
import MoreInfoMobileView from '../../Common/MoreInfoMobileView';

// Module-Specific Components
import AccountPayableInvoiceView from '../../Purchase/AccountPayableInvoice/AccountPayableInvoiceView';

// Assets
import closeIcon from '@Images/icons/icon-close-blue.png';

// Actions
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';

// Styles
import './style.scss';


const PendingAccountPayableInvoices = ({
  user,
  MONEY,
  getPendingActions,
  getPendingActionsLoading,
  pendingActions,
  priceMasking,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showSoModal, setShowSoModal] = useState(false);
  const [selectedAPInvoice, setSelectedAPInvoice] = useState(null);
  const [selectedAPInvoiceForMobile, setSelectedAPInvoiceForMobile] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const history = useHistory();

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const ListScreenKeys = ({ documentData, isDataMaskingPolicyEnable, isHideCostPrice, }) => {
    const record = documentData;

    return [
      {
        label: 'AP Invoice #',
        value: record?.ap_invoice_number,
      },
      {
        label: 'BUSINESS UNIT',
        value: record?.tenant_info?.tenant_name,
      },
      {
        label: 'VENDOR',
        value: `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim(),
      },
      {
        label: 'VENDOR INVOICE #',
        value: record?.vendor_invoice_number || '-',
      },
      {
        label: 'CREATED TIME',
        value: `${toISTDate(record?.order_date).format('DD/MM/YYYY')} by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'}`,
      },
      {
        label: 'AP Invoice DATE',
        value: toISTDate(record?.ap_invoice_date).format('DD/MM/YYYY'),
      },
      {
        label: 'GRAND TOTAL',
        value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view grand total" /> : MONEY((record?.grand_total ||'0'), record?.org_currency_info?.currency_code),
      },
    ];
  };

  const tableColumns = [
    {
      title: '',
      render: (record) => (
        <div onClick={() => {
          // this.setState({ selectedAPInvoice: record });
        }}
        >
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText text={`#${record?.ap_invoice_number}`} className="mobile-list__card_item-number" />
              </div>
              <div className="mobile-list__card_header-right">
                <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                  {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                </div>
              </div>
            </div>
            <div className="mobile-list__item-info">
              {`Business Unit - ${record.tenant_info?.tenant_name}`}
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-details">
                  {`VENDOR - ${`${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim()}`}
                </div>
                <div className="mobile-list__card_item-details">
                  {`VENDOR INVOICE # - ${record?.vendor_invoice_number || '-'}`}
                </div>
                <PRZText text={`DUE DATE - ${record?.ap_invoice_date ? dayjs(record?.ap_invoice_date).format('DD/MM/YYYY') : '-'}`} className="mobile-list__card_item-details" />
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedAPInvoiceForMobile(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
          <Drawer
            open={moreDetailsDrawer}
            width="420px"
            mask
            onClose={() => setMoreDetailsDrawer(false)}
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div
                className="custom-drawer__header"
                style={{ width: '370px' }}
              >
                <H3Text
                  text={`${selectedAPInvoiceForMobile?.ap_invoice_number}`}
                  className="custom-drawer__title"
                />
                <H3Image
                  src={closeIcon}
                  className="custom-drawer__close-icon"
                  onClick={() => setMoreDetailsDrawer(false)}
                />
              </div>
            </div>
            <MoreInfoMobileView
              description={selectedAPInvoiceForMobile?.description}
              customFields={selectedAPInvoiceForMobile?.custom_fields}
              fields={ListScreenKeys({ documentData: selectedAPInvoiceForMobile, isDataMaskingPolicyEnable: isDataMaskingPolicyEnable, isHideCostPrice: isHideCostPrice, })}
            />
          </Drawer>
        </div>
      ),
      responsive: ['xs'],
    },
    {
      title: "AP Invoice #",
      render: (text, record) => (
        <div className="column-number__wrapper">
          <H3Text text={record?.ap_invoice_number} />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'BUSINESS UNIT',
      render: (text, record) => (
        <div>
          <H3Text text={record?.tenant_info?.tenant_name} />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'VENDOR',
      render: (text, record) => (
        <React.Fragment>
          {record?.seller_info?.seller_name ? (
            <div
              className="associated-entity"
              onClick={() => history.push(`/vendors/view/${record?.seller_id}`)}
            >
              {`${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record?.seller_info?.seller_name}`?.trim()}

            </div>
          ) : '-'}
        </React.Fragment>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'VENDOR INVOICE #',
      render: (text, record) => (
        <div className="vendor-invoice">
          {record?.vendor_invoice_number || '-'}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'REFERENCE#',
      render: (text, record) => {
        const firstGrns = record?.linked_grns?.[0];
        const remainingGrns = record?.linked_grns?.slice(1) || [];
        const remainingCount = remainingGrns.length;

        return firstGrns ? (
          <Tooltip
            title={
              remainingCount > 0 ? (
                <div className="tally-locations-tooltip">
                  {remainingGrns?.map((grn, index) => (
                    <Link
                      to={`/approval?type=grn&id=${grn?.grn_id}`}
                      target="_blank"
                      style={{
                        fontWeight: 600,
                        color: "#1890ff",
                        fontSize: "13px",
                        display: "block",
                        marginBottom: "4px",
                      }}
                    >
                      {grn?.grn_number}
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="tally-locations-tooltip">
                  No additional GRNs
                </div>
              )
            }
            placement="top"
            overlayInnerStyle={{ background: "white", color: "black" }}
          >
            <span>
              <Link
                to={`/purchase/account-payable-invoice/view/${firstGrns.grn_id}`}
                target="_blank"
              >
                {firstGrns.grn_number}
              </Link>
              <span
                style={{
                  color: "gray",
                }}
              >
                {remainingCount > 0 && ` +${remainingCount} more`}
              </span>
            </span>
          </Tooltip>
        ) : (
          <span>-</span>
        );
      },
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'CREATED TIME',
      render: (record) => (
        <div>
          <div className="column-date">
            {toISTDate(record?.order_date).format('DD/MM/YYYY')}
          </div>
          <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: "AP Invoice Date",
      render: (record) => (
        <div className="column-date">
          {toISTDate(record?.ap_invoice_date).format('DD/MM/YYYY')}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'GRAND TOTAL',
      render: (item, record) => (
        <div className="column-amount">
          {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view grand total"} /> : MONEY((record?.grand_total || '0'), record?.org_currency_info?.currency_code)}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      key: 'action',
      fixed: 'right',
      render: (record) => (
        <div className="list__actions">
          <div className="list__actions-button list__actions-button-dark" onClick={() => { setSelectedAPInvoice(record); setShowSoModal(true); }}>
            View
          </div>
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      className: 'list__actions-column',
    },
  ];

  useEffect(() => {
    if (user) {
      getPendingActions('map_api', 10, currentPage, () => { });
    }
  }, [user, getPendingActions, currentPage]);
  return (
    <React.Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list___table-header__left">
                      {`${Number(pendingActions?.api_approval_count || 0)} Account Payable Invoice`}
                    </div>
                  </div>
                )}
                loading={getPendingActionsLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={tableColumns}
                dataSource={pendingActions?.account_payable_invoices || []}
                pagination={(Number(pendingActions?.api_approval_count) > 10) ? {
                  defaultCurrent: 1,
                  current: currentPage,
                  total: Number(pendingActions?.api_approval_count),
                  pageSize: 10,
                  onChange: (page) => {
                    getPendingActions('map_api', 10, page, () => { });
                    setCurrentPage(page);
                  },
                  position: ['bottomRight'],
                  showSizeChanger: false,
                } : false}
              />
            </div>
          </div>
        </div>
      </div>
      <H3Modal
        onClose={() => {
          getPendingActions('map_api', 10, currentPage, () => { });
          setShowSoModal(false);
        }}
        className="pending-api__view-api"
        isOpen={showSoModal}
        title={`Account Payable Invoice #${selectedAPInvoice ? selectedAPInvoice?.ap_invoice_number : ''} for ${selectedAPInvoice?.tenant_info?.tenant_name}`}
        showHeader
      >
        <AccountPayableInvoiceView selectedAPInvoiceId={selectedAPInvoice?.ap_invoice_id} selectedTenantId={selectedAPInvoice?.tenant_info?.tenant_id} isQuickView />
      </H3Modal>
    </React.Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});


export default connect(mapStateToProps, mapDispatchToProps)(PendingAccountPayableInvoices);
